import { useState, useEffect } from "react";
import api from "@/lib/api";
import { BookmarkSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Toggleable favorite icon for a tender.
 * Props: tenderId (required), size (default 18), className, onToggle (optional callback)
 */
export const FavoriteButton = ({ tenderId, size = 18, className = "", onToggle }) => {
  const [isFav, setIsFav] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get(`/favorites/${tenderId}/status`)
      .then((res) => { if (mounted) setIsFav(res.data.is_favorite); })
      .catch(() => {});
    return () => { mounted = false; };
  }, [tenderId]);

  const toggle = async (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      if (isFav) {
        await api.delete(`/favorites/${tenderId}`);
        setIsFav(false);
        toast.success("Eliminado de favoritos");
      } else {
        await api.post(`/favorites/${tenderId}`);
        setIsFav(true);
        toast.success("Agregado a favoritos");
      }
      if (onToggle) onToggle(!isFav);
    } catch {
      toast.error("Error al actualizar favoritos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={loading}
      data-testid={`favorite-btn-${tenderId}`}
      aria-label={isFav ? "Quitar de favoritos" : "Agregar a favoritos"}
      className={`inline-flex items-center justify-center transition-colors duration-150 hover:text-[#002FA7] ${
        isFav ? "text-[#002FA7]" : "text-muted-foreground"
      } ${loading ? "opacity-50" : ""} ${className}`}
    >
      <BookmarkSimple size={size} weight={isFav ? "fill" : "regular"} />
    </button>
  );
};
